import React, { useState } from "react"
import { Col, Container, Row } from "reactstrap"
import ProductReviews from "./ProductReviews/ProductReviews"
import SellerReviews from "./SellerReviews/SellerReviews"

const Reviews = () => {
  const tabs = ["Product Reviews", "Seller Reviews"]
  const [activeTab, setActiveTab] = useState(tabs[0])

  const metricsCol1Data = [
    { label: "Total Product Reviews:", value: "123" },
    { label: "Average Product Rating:", value: "4.8/5" },
    { label: "Positive Product Reviews:", value: "95%" },
    { label: "Negative Product Reviews:", value: "05%" },
  ]

  const metricsCol2Data = [
    { label: "Total Seller Reviews:", value: "123" },
    { label: "Average Product Rating:", value: "4.8/5" },
    { label: "Satisfaction level:", value: "95%" },
  ]

  return (
    <div style={{ background: "#f2f2f2", minHeight: "100vh", paddingBlock: "1rem" }}>
      <Container fluid>
        <h4 className="fw-semibold mb-3">Customer Reviews and Feedback</h4>
        <h5 className="fw-semibold my-3">Metrices</h5>

        <Row className="my-3 g-0 gap-3">
          <Col xs="12" xl="3" className="bg-white">
            <div className="rounded border border-black bg-white p-3 fw-medium">
              {metricsCol1Data.map((item, index) => (
                <Row className="g-0" key={index}>
                  <Col>{item.label}</Col>
                  <Col xs="2" style={{ color: "#EC7426" }}>
                    {item.value}
                  </Col>
                </Row>
              ))}
            </div>
          </Col>
          <Col xs="12" xl="3" className="bg-white" style={{ height: "fit-content" }}>
            <div className="rounded border border-black bg-white p-3 fw-medium">
              {metricsCol2Data.map((item, index) => (
                <Row className="g-0" key={index}>
                  <Col>{item.label}</Col>
                  <Col xs="2" style={{ color: "#EC7426" }}>
                    {item.value}
                  </Col>
                </Row>
              ))}
            </div>
          </Col>
        </Row>

        <div className="d-flex gap-5 my-3">
          {tabs.map((tab) => (
            <div
              className="fw-semibold"
              style={{
                color: tab === activeTab ? "#EC7426" : "inherit",
                cursor: "pointer",
                transition: "color 1s ease",
                fontSize: "1.25rem",
              }}
              onClick={() => setActiveTab(tab)}
            >
              {tab}
            </div>
          ))}
        </div>


          {activeTab === "Product Reviews" && <ProductReviews />}
          {activeTab === "Seller Reviews" && <SellerReviews />}


      </Container>
    </div>
  )
}

export default Reviews
